<script setup lang="ts">
  import { useWelcomeStore } from '~/store/welcome';

  const welcomeStore = useWelcomeStore();

  const title = computed(() => welcomeStore.notificationData?.title || '');
  const text = computed(() => welcomeStore.notificationData?.text || '');

  function onNotificationClick() {
    welcomeStore.clearNotificationData();
    navigateTo('/welcome-offer');
  }
</script>

<template>
  <div class="fixed flex z-[999] w-screen h-screen top-0 left-0 pointer-events-none sm:justify-end sm:pr-3">
    <div
      class="flex w-full h-[66px] p-2.5 justify-between items-center rounded-md border border-white/30 bg-[#121a23] backdrop-blur-[10px] absolute bottom-[100px] opacity-0 translate-y-[200px] sm:max-w-[340px] sm:bottom-auto sm:top-[68px] sm:right-5 lg:top-[78px] lg:right-10"
      :class="
        title
          ? 'animate-notification-fade-sm sm:animate-notification-fade-md pointer-events-auto opacity-100 translate-y-0 sm:translate-x-0'
          : ''
      "
      @click="onNotificationClick"
    >
      <div class="flex flex-col items-start justify-start">
        <p class="m-0 p-0 text-white font-barlow text-base font-semibold leading-[150%]">{{ title }}</p>
        <p class="m-0 p-0 text-white font-barlow text-sm font-normal leading-[150%]">{{ text }}</p>
      </div>
      <button
        class="w-11 h-11 p-2.5 rounded-full bg-white/10 cursor-pointer hover:brightness-[1.03] active:brightness-[0.97]"
      >
        <UIcon name="lucide-arrow-up-right" class="w-6 h-6 text-white" />
      </button>
    </div>
  </div>
</template>
